import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Checkbox } from 'primeng/checkbox';
import * as i0 from "@angular/core";
import * as i1 from "@angular/forms";
import * as i2 from "primeng/checkbox";
import * as i3 from "primeng/api";
import * as i4 from "@angular/common";
import * as i5 from "ngx-skeleton-loader";
import * as i6 from "../icon-v2/icon.component";
import * as i7 from "@ngx-translate/core";
const _c0 = () => ({
  height: "24px",
  width: "24px",
  "margin-right": "16px"
});
const _c1 = () => ({
  height: "16px",
  width: "90px",
  bottom: "4px"
});
function CheckboxV2Component_ng_container_0_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "geaui-icon-v2", 4);
  }
}
function CheckboxV2Component_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "p-checkbox", 2);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("mouseleave", function CheckboxV2Component_ng_container_0_Template_p_checkbox_mouseleave_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onMouseLeave());
    })("onChange", function CheckboxV2Component_ng_container_0_Template_p_checkbox_onChange_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.changed.emit($event.checked));
    });
    i0.ɵɵtemplate(3, CheckboxV2Component_ng_container_0_ng_template_3_Template, 1, 0, "ng-template", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", ctx_r1.id)("label", i0.ɵɵpipeBind1(2, 4, ctx_r1.label))("formControl", ctx_r1.control)("binary", true);
  }
}
function CheckboxV2Component_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelement(1, "ngx-skeleton-loader", 6)(2, "ngx-skeleton-loader", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(2, _c0));
    i0.ɵɵadvance();
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(3, _c1));
  }
}
export class CheckboxV2Component {
  formBuilder;
  label = '';
  id = 'checkbox';
  formName = undefined;
  form;
  initialValue = false;
  loading = false;
  disabled = false;
  changed = new EventEmitter();
  checkbox;
  get control() {
    return this.form?.get(this.formName ?? this.id);
  }
  constructor(formBuilder) {
    this.formBuilder = formBuilder;
    this.form = this.form || this.formBuilder.group({
      [this.formName ?? this.id]: new FormControl(false, [])
    });
    this.control?.registerOnDisabledChange(isDisabled => this.checkbox?.setDisabledState(isDisabled));
  }
  ngOnInit() {
    if (this.initialValue) {
      this.control?.setValue(this.initialValue);
    }
  }
  // couple the disabled input to the formField
  ngOnChanges(changes) {
    if (changes['disabled']) {
      const isDisabled = changes['disabled'].currentValue;
      isDisabled ? this.control?.disable() : this.control?.enable();
    }
  }
  onMouseLeave() {
    this.checkbox.focused = false;
  }
  static ɵfac = function CheckboxV2Component_Factory(t) {
    return new (t || CheckboxV2Component)(i0.ɵɵdirectiveInject(i1.FormBuilder));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CheckboxV2Component,
    selectors: [["geaui-checkbox-v2"]],
    viewQuery: function CheckboxV2Component_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(Checkbox, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.checkbox = _t.first);
      }
    },
    inputs: {
      label: "label",
      id: "id",
      formName: "formName",
      form: "form",
      initialValue: "initialValue",
      loading: "loading",
      disabled: "disabled"
    },
    outputs: {
      changed: "changed"
    },
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 3,
    vars: 2,
    consts: [["skeleton", ""], [4, "ngIf", "ngIfElse"], [3, "mouseleave", "onChange", "id", "label", "formControl", "binary"], ["pTemplate", "icon"], ["file", "16px_check", 1, "gea-checkbox-icon"], [1, "loading-container"], ["count", "1", "appearance", "line", 3, "theme"]],
    template: function CheckboxV2Component_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, CheckboxV2Component_ng_container_0_Template, 4, 6, "ng-container", 1)(1, CheckboxV2Component_ng_template_1_Template, 3, 4, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        const skeleton_r3 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", !ctx.loading)("ngIfElse", skeleton_r3);
      }
    },
    dependencies: [i2.Checkbox, i3.PrimeTemplate, i1.NgControlStatus, i1.FormControlDirective, i4.NgIf, i5.NgxSkeletonLoaderComponent, i6.IconComponent, i7.TranslatePipe],
    styles: [".loading-container[_ngcontent-%COMP%]{height:24px}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CheckboxV2Component, [{
    type: Component,
    args: [{
      selector: 'geaui-checkbox-v2',
      template: "<ng-container *ngIf=\"!loading; else skeleton\">\n  <p-checkbox\n    [id]=\"id\"\n    [label]=\"label | translate\"\n    [formControl]=\"control\"\n    [binary]=\"true\"\n    (mouseleave)=\"onMouseLeave()\"\n    (onChange)=\"changed.emit($event.checked)\">\n    <ng-template pTemplate=\"icon\">\n      <geaui-icon-v2 class=\"gea-checkbox-icon\" file=\"16px_check\"></geaui-icon-v2>\n    </ng-template>\n  </p-checkbox>\n</ng-container>\n<ng-template #skeleton>\n  <div class=\"loading-container\">\n    <ngx-skeleton-loader\n      [theme]=\"{ height: '24px', width: '24px', 'margin-right': '16px' }\"\n      count=\"1\"\n      appearance=\"line\"></ngx-skeleton-loader>\n    <ngx-skeleton-loader\n      [theme]=\"{ height: '16px', width: '90px', bottom: '4px' }\"\n      count=\"1\"\n      appearance=\"line\"></ngx-skeleton-loader>\n  </div>\n</ng-template>\n",
      styles: [".loading-container{height:24px}\n"]
    }]
  }], () => [{
    type: i1.FormBuilder
  }], {
    label: [{
      type: Input
    }],
    id: [{
      type: Input
    }],
    formName: [{
      type: Input
    }],
    form: [{
      type: Input
    }],
    initialValue: [{
      type: Input
    }],
    loading: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    changed: [{
      type: Output
    }],
    checkbox: [{
      type: ViewChild,
      args: [Checkbox]
    }]
  });
})();
